import { render, staticRenderFns } from "./NavbarDesktop.vue?vue&type=template&id=13a83a85&scoped=true"
import script from "./NavbarDesktop.vue?vue&type=script&lang=js"
export * from "./NavbarDesktop.vue?vue&type=script&lang=js"
import style0 from "./NavbarDesktop.vue?vue&type=style&index=0&id=13a83a85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a83a85",
  null
  
)

export default component.exports